import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader({show}) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: show?'flex':'none',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999, // High z-index to ensure it's on top of all other components
      }}
    >
      <CircularProgress sx={{color:'white'}} />
    </Box>
  );
}
